import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { RiDeleteBinLine } from "react-icons/ri";

import { FaRegClock, FaRegEdit } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { IoChatbubbleOutline } from "react-icons/io5";
import { CiVideoOn } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { LuVideo } from "react-icons/lu";
import { TiStarFullOutline } from "react-icons/ti";
import { TfiStatsUp } from "react-icons/tfi";
import { FcBarChart } from "react-icons/fc";
import { RiBarChart2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { getCreatorBookings } from "../../redux/actions/mindfulness";
import { Loader } from "./MindfulnessStyles";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// Dummy data for bookings
const dummyBookings = {
  totalBookings: 7,
  upcoming: 5,
  completed: 2,
  cancelled: 0,
  upcomingBookings: [
    {
      id: 1,
      sessionTitle: "Anxiety Management Session",
      clientName: "Ananya K.",
      format: "Chat",
      date: "2024-03-25",
      time: "10:00 AM",
      price: 500,
      status: "upcoming",
    },
    {
      id: 2,
      sessionTitle: "Relationship Counseling",
      clientName: "Rahul M.",
      format: "Video",
      date: "2024-03-26",
      time: "2:00 PM",
      price: 1200,
      status: "upcoming",
    },
    {
      id: 3,
      sessionTitle: "Career Counseling Call",
      clientName: "Priya S.",
      format: "Call",
      date: "2024-03-27",
      time: "4:30 PM",
      price: 800,
      status: "upcoming",
    },
    {
      id: 4,
      sessionTitle: "Stress Relief & Mindfulness",
      clientName: "Arjun V.",
      format: "Video",
      date: "2024-03-28",
      time: "11:00 AM",
      price: 900,
      status: "upcoming",
    },
    {
      id: 5,
      sessionTitle: "Academic Pressure Support",
      clientName: "Sneha P.",
      format: "Chat",
      date: "2024-03-29",
      time: "9:00 AM",
      price: 600,
      status: "upcoming",
    },
  ],
  completedBookings: [
    {
      id: 6,
      sessionTitle: "Life Coaching Session",
      clientName: "Vikram R.",
      format: "Video",
      date: "2024-03-20",
      time: "3:00 PM",
      price: 1000,
      status: "completed",
    },
    {
      id: 7,
      sessionTitle: "Time Management Workshop",
      clientName: "Neha G.",
      format: "Chat",
      date: "2024-03-22",
      time: "11:00 AM",
      price: 750,
      status: "completed",
    },
  ],
};

// Styled Components
const BookingsContainer = styled.div`
  padding: 20px;
  background-color: #fff;
  font-family: Montserrat;
  font-weight: 400;

  margin: auto;
  margin-top: 90px;
  width: 80%;
`;

const Header = styled.div`
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  padding: 2.9375rem 2.1875rem;
  border-radius: 12px;
  color: white;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-sizing: border-box;
  padding-top: 3.75rem;
  border-top: 1px solid rgba(237, 30, 36, 1);
  border-radius: 15px 15px 0px 0px;
  background: linear-gradient(
    180deg,
    rgba(255, 106.66, 110.96, 1) 39%,
    rgba(237, 30, 36, 1) 100%
  );
`;

const HeaderTitle = styled.div`
  h1 {
    font-size: 1.875rem;
    margin: 0;
    font-weight: 400;
  }
  p {
    font-size: 1rem;
    font-weight: 400;
    opacity: 0.9;
    margin: 5px 0 0;
  }
`;

const EditProfileButton = styled.button`
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const StatCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #E5E7EB;

  ${(props) =>
    props.variant === "upcoming" &&
    `
    border: 1px solid #BEDBFF;
    background-color: #EFF6FF;
  `}

  ${(props) =>
    props.variant === "completed" &&
    `
    border: 1px solid #B9F8CF;
    background-color: #F0FDF4;
  `}
  
  ${(props) =>
    props.variant === "cancelled" &&
    `
    border: 1px solid #E5E7EB;
    background-color: #F9FAFB;
  `}
`;

const StatTitle = styled.h3`
  font-size: 14px;
  font-weight: 400;
  color: #666;
  margin: 0;
`;

const StatValue = styled.p`
  font-size: 24px;
  font-weight: 400;
  margin: 0;
  color: ${(props) => props.color || "#333"};
`;

const SectionHeader = styled.div`
  margin-bottom: 20px;

  h2 {
    color: rgba(16, 24, 40, 1);
    font-family: Montserrat;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: left;
  }

  p {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
`;

const BookingsList = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
`;

const BookingItem = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9f9f9;
  }
`;

const BookingIcon = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: #ffebee;
  color: #ff6b6b;
  margin-right: 15px;
`;

const BookingDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;

  .session-title {
    font-weight: 400;
    color: #333;
    font-size: 16px;
  }

  .client-name {
    font-size: 14px;
    color: #666;
  }

  .format-tag {
    display: inline-block;
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    margin-left: 8px;
  }
`;

const BookingTime = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin-left: 20px;

  .date {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .time {
    font-size: 14px;
    color: #666;
  }
`;

const BookingPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin-left: 20px;

  .amount {
    font-size: 1rem;
    font-weight: 400;
    color: #333;
    margin-bottom: 5px;
  }

  .status {
    display: inline-block;
    background-color: #dcfce7;
    color: #155dfc;
    padding: 4px 8px;
    border-radius: 26843500px;
    background: #dbeafe;
    font-size: 12px;
    font-weight: 400;
    text-transform: capitalize;

    ${(props) =>
      props.status === "upcoming" &&
      `
      background-color: #bbdefb;
      color: #1976d2;
    `}

    ${(props) =>
      props.status === "completed" &&
      `
      background-color: #F3F4F6;
      color: #4A5565;
    `}
    
    ${(props) =>
      props.status === "cancelled" &&
      `
      background-color: #ffcdd2;
      color: #d32f2f;
    `}
  }
`;

const BookingArrow = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  margin-left: 10px;
`;

const FooterBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #eee;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
`;

const FooterButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.active ? "#e3f2fd" : "#f5f5f5")};
  color: ${(props) => (props.active ? "#1976d2" : "#666")};
  border: ${(props) => (props.active ? "1px solid #bbdefb" : "1px solid #ddd")};
  cursor: pointer;
  font-size: 20px;

  &:hover {
    background-color: ${(props) => (props.active ? "#e3f2fd" : "#eee")};
  }
`;

const ViewAllCreatorBookings = () => {
  const [activeTab, setActiveTab] = useState("upcoming");

  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const dispatch = useDispatch();

  const bookingData = useSelector((state) => state?.mindfulness.bookings);
  // const bookingData = newTestData;

  useEffect(async () => {
    await dispatch(getCreatorBookings());
    setIsLoading(false);
  }, []);

  console.log("viewAllCreatorBookings", bookingData);

  if (isLoading) {
    return <Loader />;
  }

  // Extract data from bookingData
  const upcomingBookings = bookingData?.upcoming_bookings || [];
  const completedBookings = bookingData?.completed_bookings || [];
  const cancelledBookings = bookingData?.cancelled_bookings || [];
  const totalBookings = bookingData?.total_bookings || 0;
  const upcoming = upcomingBookings.length;
  const completed = completedBookings.length;
  const cancelled = cancelledBookings.length;

  // Helper function to format date from ISO string
  const formatDate = (isoString) => {
    return moment(isoString).format("DD MMM YYYY");
  };

  // Helper function to format time from ISO string
  const formatTime = (isoString) => {
    return moment(isoString).format("hh:mm A");
  };

  // Helper function to capitalize format
  const formatType = (type) => {
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  return (
    <BookingsContainer>
      {/* Header */}
      <Header>
        <HeaderTitle>
          <h1>All Bookings</h1>
          <p>Complete list of all your session bookings</p>
        </HeaderTitle>
        {/* <EditProfileButton>
          <img src="/Image/mindfulness/edit-profile.svg" />
          Edit Profile
        </EditProfileButton> */}
      </Header>

      {/* Stats Cards */}
      <StatsContainer>
        <StatCard>
          <StatTitle>Total Bookings</StatTitle>
          <StatValue>{totalBookings}</StatValue>
        </StatCard>

        <StatCard variant="upcoming">
          <StatTitle>Upcoming</StatTitle>
          <StatValue color="#155DFC">{upcoming}</StatValue>
        </StatCard>

        <StatCard variant="completed">
          <StatTitle>Completed</StatTitle>
          <StatValue color="#388e3c">{completed}</StatValue>
        </StatCard>

        <StatCard variant="cancelled">
          <StatTitle>Cancelled</StatTitle>
          <StatValue color="#d32f2f">{cancelled}</StatValue>
        </StatCard>
      </StatsContainer>

      {/* Upcoming Bookings */}
      <SectionHeader>
        <h2>Upcoming Bookings</h2>
      </SectionHeader>

      <BookingsList>
        {upcomingBookings?.length === 0 && <p style={{textAlign: 'center', padding: '1rem'}}>No Upcoming Bookings</p>}
        {upcomingBookings.map((booking) => (
          <BookingItem key={booking?.id} onClick={()=>history.push({
            pathname: "/booking_details",
            state: {
              bookingId: booking?.id,
            }
          })}>
            <BookingIcon>
              {booking?.type === "chat" && (
                <IoChatbubbleOutline color="#ff6b6b" />
              )}
              {booking?.type === "call" && <IoCallOutline color="#ff6b6b" />}
              {booking?.type === "video" && <LuVideo color="#ff6b6b" />}
            </BookingIcon>
            <BookingDetails>
              <div className="session-title">{booking?.session_name}</div>
              <div className="client-name">
                {booking?.user_name}
                <span className="format-tag">{formatType(booking?.type)}</span>
              </div>
            </BookingDetails>
            <BookingTime>
              <div className="date">{formatDate(booking?.start_time)}</div>
              <div className="time">{formatTime(booking?.start_time)}</div>
            </BookingTime>
            <BookingPrice>
              <div className="amount">₹{booking?.amount}</div>
              <div className="status" status={booking?.status}>
                {booking?.status}
              </div>
            </BookingPrice>
            {/* <BookingArrow>→</BookingArrow> */}
          </BookingItem>
        ))}
      </BookingsList>

      {/* Completed Bookings */}
      <SectionHeader>
        <h2>Completed Bookings</h2>
      </SectionHeader>

      <BookingsList>
        {completedBookings?.length === 0 && <p style={{textAlign: 'center', padding: '1rem'}}>No Completed Bookings</p>}
        {completedBookings.map((booking) => (
          <BookingItem key={booking?.id}>
            <BookingIcon style={{ backgroundColor: "#F0FDF4" }}>
              {booking?.type === "chat" && (
                <IoChatbubbleOutline color="#00A63E" />
              )}
              {booking?.type === "call" && <IoCallOutline color="#00A63E" />}
              {booking?.type === "video" && <LuVideo color="#00A63E" />}
            </BookingIcon>
            <BookingDetails>
              <div className="session-title">{booking?.session_name}</div>
              <div className="client-name">
                {booking?.user_name}
                <span className="format-tag">{formatType(booking?.type)}</span>
              </div>
            </BookingDetails>
            <BookingTime>
              <div className="date">{formatDate(booking?.start_time)}</div>
              <div className="time">{formatTime(booking?.start_time)}</div>
            </BookingTime>
            <BookingPrice>
              <div className="amount">₹{booking?.amount}</div>
              <div className="status" status={booking?.status}>
                {booking?.status}
              </div>
            </BookingPrice>
          </BookingItem>
        ))}
      </BookingsList>
    </BookingsContainer>
  );
};

export default ViewAllCreatorBookings;

const newTestData = {
  upcoming_bookings: [
    {
      id: 6,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. Charles Xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-10T10:00:00Z",
      duration: 60,
      end_time: "2026-02-10T11:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-05T14:11:07.454568Z",
      utimestamp: "2026-02-05T14:11:07.454582Z",
      creator_session: 17,
      user: 391,
    },
  ],
  completed_bookings: [
    {
      id: 4,
      user_name: "Katherine Pryde",
      session_name: "Mindfulness Meditation",
      creator_name: "Dr. Jean Grey",
      amount: 2500,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/392/dpImages/392-dr-jean-grey.jpg",
      type: "video",
      start_time: "2026-01-28T15:30:00Z",
      duration: 45,
      end_time: "2026-01-28T16:15:00Z",
      status: "completed",
      notes: "Great session, felt much more relaxed",
      transaction: {
        id: 12345,
        payment_status: "success",
      },
      is_active: false,
      timestamp: "2026-01-28T16:20:00Z",
      utimestamp: "2026-01-28T16:20:00Z",
      creator_session: 15,
      user: 391,
    },
    {
      id: 2,
      user_name: "Katherine Pryde",
      session_name: "Career Counseling",
      creator_name: "Prof. Charles Xavier",
      amount: 3500,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-01T09:00:00Z",
      duration: 60,
      end_time: "2026-02-01T10:00:00Z",
      status: "completed",
      notes: "",
      transaction: {
        id: 12344,
        payment_status: "success",
      },
      is_active: false,
      timestamp: "2026-02-01T10:05:00Z",
      utimestamp: "2026-02-01T10:05:00Z",
      creator_session: 12,
      user: 391,
    },
  ],
  cancelled_bookings: [
    {
      id: 5,
      user_name: "Katherine Pryde",
      session_name: "Stress Management Workshop",
      creator_name: "Dr. Jean Grey",
      amount: 2000,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/392/dpImages/392-dr-jean-grey.jpg",
      type: "video",
      start_time: "2026-02-07T14:00:00Z",
      duration: 90,
      end_time: "2026-02-07T15:30:00Z",
      status: "cancelled",
      notes: "Had to cancel due to work emergency",
      transaction: null,
      is_active: false,
      timestamp: "2026-02-04T10:15:00Z",
      utimestamp: "2026-02-04T10:15:00Z",
      creator_session: 16,
      user: 391,
    },
    {
      id: 3,
      user_name: "Katherine Pryde",
      session_name: "Goal Setting Session",
      creator_name: "Logan (Wolverine)",
      amount: 1800,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/390/dpImages/390-logan-wolverine.jpg",
      type: "call",
      start_time: "2026-02-03T18:00:00Z",
      duration: 30,
      end_time: "2026-02-03T18:30:00Z",
      status: "cancelled",
      notes: "Creator cancelled - scheduling conflict",
      transaction: null,
      is_active: false,
      timestamp: "2026-02-02T12:30:00Z",
      utimestamp: "2026-02-02T12:30:00Z",
      creator_session: 14,
      user: 391,
    },
  ],
  total_bookings: 6,
};
